/**
 * The in-app banner for a time proposal (decision 160; booking-contracts.md 15): the push's words, shown in the
 * app when its in-app notification lands, in place of a toast. One at a time, the newest.
 */
export interface ProposalBannerItem { id: string; title: string; message: string; link?: string }

const PROPOSAL_EVENTS = new Set(['lesson_time_proposal', 'lesson_time_proposal_reminder']);

let current: ProposalBannerItem | null = null;
const listeners = new Set<() => void>();

export function isProposalEvent(data: Record<string, unknown> | undefined): boolean {
  return PROPOSAL_EVENTS.has(String(data?.liveEvent ?? ''));
}

export function showProposalBanner(item: ProposalBannerItem): void {
  current = item;
  listeners.forEach((l) => l());
}

export function dismissProposalBanner(): void {
  current = null;
  listeners.forEach((l) => l());
}

export function proposalBanner(): ProposalBannerItem | null {
  return current;
}

export function subscribeProposalBanner(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}
